// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1JKzY","inner":"Footer_inner__vm4xE","nextIcon":"Footer_nextIcon__2pxN8","innerLeft":"Footer_innerLeft__3D4kd"};